export class Zork {
    init() {
        Zork.csrfToken = this.getMetaContent('_csrf');
        Zork.csrfHeader = this.getMetaContent('_csrf_header');
    }
    getMetaContent(name) {
        const element = document.querySelector(`meta[name="${name}"]`);
        return element ? element.getAttribute('content') : null;
    }
}
Zork.csrfToken = null;
Zork.csrfHeader = null;
